import React from 'react';
import { motion } from 'framer-motion';

interface NumberKeypadProps {
  onNumberClick: (number: number) => void;
  onDeleteClick: () => void;
  onSubmitClick: () => void;
}

export const NumberKeypad: React.FC<NumberKeypadProps> = ({ onNumberClick, onDeleteClick, onSubmitClick }) => {
  const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

  return (
    <div className="number-keypad">
      <div className="keypad-grid">
        {numbers.map((number) => (
          <motion.button
            key={number}
            className="keypad-button"
            onClick={() => onNumberClick(number)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            {number}
          </motion.button>
        ))}
        <motion.button
          className="keypad-button delete-button"
          onClick={onDeleteClick}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          Delete
        </motion.button>
        <motion.button
          className="keypad-button submit-button"
          onClick={onSubmitClick}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          Submit
        </motion.button>
      </div>
    </div>
  );
};